module.exports = __webpack_public_path__ + "img/default-crypto.2e9ba441.svg";